// Short relative time for list rows: "just now", "3 hours ago", "in 5 days".
// Input is anything Date can parse (UTC ISO strings from lambdas). Returns '' for
// empty or invalid input. Beyond ~30 days callers should fall back to the group's
// date format, which stays legible where "47 days ago" does not.
export function relativeTime(input, now = new Date()) {
  if (!input) return ''
  const then = input instanceof Date ? input : new Date(input)
  if (Number.isNaN(then.getTime())) return ''

  const diffMs = then.getTime() - now.getTime()
  const future = diffMs > 0
  const abs = Math.abs(diffMs)
  const minute = 60 * 1000
  const hour = 60 * minute
  const day = 24 * hour

  let value
  let unit
  if (abs < minute) return future ? 'in a moment' : 'just now'
  if (abs < hour) { value = Math.round(abs / minute); unit = 'minute' }
  else if (abs < day) { value = Math.round(abs / hour); unit = 'hour' }
  else { value = Math.round(abs / day); unit = 'day' }

  const label = `${value} ${unit}${value === 1 ? '' : 's'}`
  return future ? `in ${label}` : `${label} ago`
}

// True when the input is more than `days` days away from now in either direction.
export function olderThanDays(input, days, now = new Date()) {
  if (!input) return false
  const then = input instanceof Date ? input : new Date(input)
  if (Number.isNaN(then.getTime())) return false
  return Math.abs(then.getTime() - now.getTime()) > days * 24 * 60 * 60 * 1000
}
